module.exports = __webpack_public_path__ + "img/banner_app.e9f3587c.png";